import { render, staticRenderFns } from "./Nose.vue?vue&type=template&id=1eabde56&scoped=true&"
import script from "./Nose.vue?vue&type=script&lang=js&"
export * from "./Nose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eabde56",
  null
  
)

export default component.exports